export const getNextImageIndex = (
    orientation,
    thumbnailsLength,
    activeIndex,
) => {
    let nextImageIndex;

    if (orientation === 'left') {
        if (activeIndex === 0) {
            nextImageIndex = thumbnailsLength - 1;
        } else {
            nextImageIndex = activeIndex - 1;
        }
    } else if (orientation === 'right') {
        if (activeIndex === thumbnailsLength - 1) {
            nextImageIndex = 0;
        } else {
            nextImageIndex = activeIndex + 1;
        }
    }
    return nextImageIndex;
};
